import React, { FC } from 'react';
import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import styles from './FacialAgeComponent.module.scss';
import { WellnessItem } from '../../../services/DataFormatService';
import boddVariables from '../../../variables.module.scss';
import FacialAgeIcon from '../../../assets/facialage.svg';

interface FacialAgeComponentProps {
    facialAgeItem: WellnessItem,
}

const FacialAgeComponent: FC<FacialAgeComponentProps> = (props) => {
    const { facialAgeItem } = props;
    return (
        <Box
            className={styles.FacialAgeComponent}
            data-testid="FacialAgeComponent"
            sx={{
                bgcolor: boddVariables.white,
                border: 2,
                borderColor: boddVariables.grey50,
                borderRadius: 1.75,
                py: 2,
            }}
        >
            <Stack alignItems="center" justifyContent="space-evenly" spacing={1}>
                <SvgIcon sx={{ height: 39, width: 39 }}><FacialAgeIcon /></SvgIcon>
                <Typography sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '400',
                    fontSize: '14px',
                    lineHeight: '15px',
                    color: boddVariables.black,
                    px: 3,
                    pt: 1,
                    minHeight: '30px',
                    textAlign: 'center',
                }}
                >
                    Facial Skin Age
                </Typography>
                <Typography sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '30px',
                    color: boddVariables.black,
                }}
                >
                    {facialAgeItem.formattedValue}
                    {' '}
                    years
                </Typography>
            </Stack>
        </Box>
    );
};

export default FacialAgeComponent;
